<template>
  <card>
    <template #header>
      <card-header>{{ $t(title) }}</card-header>
    </template>
    <div class="approvals">
      <div v-for="(item,index) in items" :key="index" class="approval" @click="to(item)">
        <div class="approval-num">{{ item.num }}</div>
        <div class="approval-name">{{ $tc(item.text, item.num) }}</div>
      </div>
    </div>
  </card>
</template>

<script>
export default {
  name: "",
  components: {},
  mixins: [],
  props: {
    title: {
      type: String,
      default: ""
    },
    items: {
      type: Array
    }
  },
  data() {
    return {
      // title:'Pending My Approval',
      // items:[
      //   {
      //     num:1,
      //     text:'flow.companyProcess'
      //   },{
      //     num:7,
      //     text:'flow.projectProcess'
      //   }
      // ]
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  destroyed() {},
  methods: {
    to(item) {
      if (item.path) {
        if (item.query) {
          this.$router.push({ path: item.path,query:item.query });
        } else {
          this.$router.push({ path: item.path });
        }
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.approvals {
  height: 130px;
  display: flex;
  justify-content: space-around;
  align-items: center;

  .approval {
    text-align: center;
    width: 130px;
    cursor: pointer;

    .approval-num {
      color: #fe0000;
      font-size: 56px;
      font-weight: bold;
    }
    .approval-name {
      color: #666666;
      font-size: 13px;
      height: 15px;
      margin-top: 10px;
      display: inline-block;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
  }
}
</style>
